import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { CaseManagementService } from '../../../services/caseManagement.service';
import { ViewDetailModalComponent } from '../view-detail-modal/view-detail-modal.component';
import { ViewNotesComponent } from '../view-notes/view-notes.component';

@Component({
  selector: 'show-wo-popup',
  templateUrl: './show-wo-popup.component.html',
  styleUrls: ['./show-wo-popup.component.scss']
})
export class ShowWoPopupComponent implements OnInit {

  popupHeader: String = '';
  loading: boolean = false;
  showPendingTable: boolean = false;
  showActiveDispatchTable: boolean = false;
  showEVerifyTable: boolean = false;
  showCompleteVerifyTable: boolean = false;
  pendingTableData: any;
  WOTableData: any;
  checkIsDemo: boolean = false;
  status: string = 'Pending';
  woStatus: string;
  roStatus: string;

  constructor(
    public dialogRef: MatDialogRef<ShowWoPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private caseManagementService: CaseManagementService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {

    this.checkIsDemo = (sessionStorage.getItem('isDemo')) ? true : false;

    if (this.data.barSelected === 1) {
      this.roStatus = '1141,1623';

      if (this.checkIsDemo) {
        this.showPendingTable = true;
        const caseSummaryReport = sessionStorage.getItem('caseSummaryReport');
        const summaryReport = JSON.parse(caseSummaryReport);
        let dateFirst = new Date(summaryReport.WoSubmitDate);
        let dateSecond = new Date();
        let diffMs = (dateSecond.getTime() - dateFirst.getTime()); // milliseconds between now & Christmas
        let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes

        this.pendingTableData = [{
          wONumber: summaryReport.wokey,
          wOStatus: summaryReport.wostatusStr,
          pendingMins: diffMins,
          customerName: summaryReport.customerName,
          wODate: summaryReport.WoSubmitDate,
          serviceName: summaryReport.serviceName,
          complaint: summaryReport.serviceDescription
        }];
      } else {
        const reqData = {
          'customer_key': sessionStorage.getItem('legacyCustomerKeyId'),
          'subcustomer_key': sessionStorage.getItem('hierarchySubCustomerKey') == null ? "0" : sessionStorage.getItem('hierarchySubCustomerKey'),
          'division_id': sessionStorage.getItem('hierarchyDivisionId') == null ? "0" : sessionStorage.getItem('hierarchyDivisionId'),
          'location_id': sessionStorage.getItem('hierarchyLocationId') == null ? "0" : sessionStorage.getItem('hierarchyLocationId'),
          'ro_statuses': this.roStatus
        };
        this.loading = true;
        this.caseManagementService.getPendingDispatchRODetails(reqData).subscribe((res: any) => {
          this.showPendingTable = true;
          this.pendingTableData = res;
          this.loading = false;
        });
      }
    } else {

      if (this.data.barSelected == 2) {
        this.roStatus = '962';
      }
      if (this.data.barSelected == 3) {
        this.roStatus = '963,964,1373,1374,1363';
      }

      if (this.data.barSelected == 4) {
        this.roStatus = '1156,1155,1624'; //'1146,1157';
      }

      if (this.data.barSelected == 5) {
        this.roStatus = ''
      }

      this.showCompleteVerifyTable = true;

      if (this.checkIsDemo) {
        const caseSummaryReport = sessionStorage.getItem('caseSummaryReport');
        const summaryReport = JSON.parse(caseSummaryReport);
        let dateFirst = new Date(summaryReport.WoSubmitDate);
        let dateSecond = new Date();
        let diffMs = (dateSecond.getTime() - dateFirst.getTime()); // milliseconds between now & Christmas
        let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
        let diffDays = Math.floor(diffMs / 86400000); // days

        let currentDate2 = new Date(dateSecond);
        const maxETA = currentDate2.setMinutes(dateSecond.getMinutes() + 15);

        this.WOTableData = [{
          wONumber: summaryReport.wokey,
          dIP: '',//'119641',
          pendingMins: diffMins,
          totalRefusals: 0,
          agentName: '',//'Dev-Nitin',
          customerName: summaryReport.customerName,
          customer: summaryReport.customerName,
          stateAndCity: summaryReport.breakdownCity,
          maintPlan: 'Emergency Roadside',
          wODate: summaryReport.WoSubmitDate,
          serviceName: summaryReport.serviceName,
          service: summaryReport.serviceName,
          complaint: summaryReport.serviceDescription,
          tSQExternalAssetId: summaryReport.faassetId,
          serviceDescription: summaryReport.serviceDescription,
          wOStatus: summaryReport.wostatusStr,
          asOf: summaryReport.WoSubmitDate,
          wOCurrentDT: diffDays,
          wOExpectedDT: diffDays,
          wOTotalCost: '$185.00',
          wONote: '',
          providerName: 'Test Provider',
          mAXETA: maxETA,
          assetDescription: 'Complaint entered during intake'
        }];
      } else {
        const dataReq = {
          'customer_key': sessionStorage.getItem('legacyCustomerKeyId'),
          'subcustomer_key': sessionStorage.getItem('hierarchySubCustomerKey') == null ? "0" : sessionStorage.getItem('hierarchySubCustomerKey'),
          'division_id': sessionStorage.getItem('hierarchyDivisionId') == null ? "0" : sessionStorage.getItem('hierarchyDivisionId'),
          'location_id': sessionStorage.getItem('hierarchyLocationId') == null ? "0" : sessionStorage.getItem('hierarchyLocationId'),
          'ro_statuses': this.roStatus
        };
        this.loading = true;
        this.caseManagementService.getRODetailsByStatus(dataReq).subscribe((res: any) => {
          this.WOTableData = res;
          this.loading = false;
        });
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close(0);
  }

  viewNotes(WONumber) {
    this.caseManagementService.setWorkOrderKey(WONumber);
    this.dialog.open(ViewNotesComponent, {
      hasBackdrop: true,
      height: '90%',
      maxHeight: '90%',
      width: '60%',
      backdropClass: 'cdk-overlay-transparent-backdrop',
      position: {
        top: '5%',
        bottom: '',
        left: '',
        right: ''
      }
    });
  }

  public viewDetails(woNumber): void {
    this.dialog.open(ViewDetailModalComponent, {
      height: 'auto',
      maxHeight: '90%',
      width: '90%',
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      data: { 'woNumber': woNumber }
    });
  }

}

